import { useExtensionUnits } from '../../hooks/calculator/useExtensionUnits.js';
import {useMultimediaLevels } from '../../hooks/calculator/useMultimediaLevels.js';
import { useInstructionalLevels } from '../../hooks/calculator/useInstructionalLevels.js';

export default function Descriptions() {
    // Traer las demas listas
    const { extensionUnits, loading: loadingExtensions } = useExtensionUnits();
    const { multimediaLevels, loading: loadingMultimedia } = useMultimediaLevels();
    const { instructionalLevels, loading: loadingInstructional } = useInstructionalLevels();
    
    const isLoading = loadingExtensions || loadingMultimedia || loadingInstructional;

    if (isLoading) {
        return (
            <div className="text-center mt-6">
                <div className="spinner-grow text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="container mt-6"> 
                <div className="bg-body-tertiary py-4 px-5 mb-4 rounded">
                    <h4 className="pb-4">Cursos</h4>
                    <div className="list-group">
                        <div className="list-group-item">
                            <h6 className="fw-bold">Actividades a medida</h6>
                            <p className="mb-0 text-muted">Indicar cantidad de actividades diseñadas a medida se gusta agregar para variar la interacción en cursos de Rise.</p>
                        </div>
                    </div>
                    <h4 className="pb-4 mt-4">Diseño Instruccional</h4>
                    <div className="list-group">
                        {instructionalLevels.map(il => (
                            <div key={il.id} className="list-group-item">
                                <h6 className="fw-bold">{il.name}</h6>
                                <p className="mb-0 text-muted">{il.description}</p>
                            </div>
                        ))}
                    </div>
                    <h4 className="pb-4 mt-4">Diseño Multimedia</h4>
                    <div className="list-group">
                        {multimediaLevels.map(il => (
                            <div key={il.id} className="list-group-item">
                                <h6 className="fw-bold">{il.name}</h6>
                                <p className="mb-0 text-muted">{il.description}</p>
                            </div>
                        ))}
                    </div>
                    <h4 className="pb-4 mt-4">Medida de extensión</h4>
                    <div className="list-group">
                        {extensionUnits.map(eu => (
                            <div key={eu.id} className="list-group-item">
                                <h6 className="fw-bold">{eu.name}</h6>
                                <p className="mb-0 text-muted">{eu.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="bg-body-tertiary py-4 px-5 mb-4 rounded">
                    <div id='instruccional'></div>
                    <h4 className="pb-4">Videos</h4>
                    <h4 className="pb-4 mt-4">Diseño Instruccional</h4>
                    <div className="list-group">
                        <div className="list-group-item">
                            <h6 className="fw-bold">Alto</h6>
                            <p className="mb-0 text-muted">El contenido no está presentado en un solo documento y requiere el levantamiento de contenido para estructurar el guion. También aplica para el diseño instruccional de recursos tipo, casos, árboles de decisiones y storytelling, entre otros.</p>
                        </div>
                        <div className="list-group-item">
                            <h6 className="fw-bold">Básico</h6>
                            <p className="mb-0 text-muted">El contenido se presenta en documento o presentación ya estructurado y el Diseñador Instruccional realizará un guion aplicando los ajustes básicos necesarios para su adaptación al video.</p>
                        </div>
                        <div className="list-group-item">
                            <h6 className="fw-bold">Medio</h6>
                            <p className="mb-0 text-muted">El contenido presentado requiere la reestructuración por parte del Diseñador Instruccional, quien al realizar el guion definirá las estrategias de visualización, así como los estándares necesarios para su adaptación a a video.</p>
                        </div>
                        <div className="list-group-item">
                            <h6 className="fw-bold">Sin DI</h6>
                            <p className="mb-0 text-muted">El contenido será entregado por parte del cliente en formato de guion y no requiere la interveción de un Diseñador Instruccional.</p>
                        </div>
                    </div>
                    <div id='multimedia'></div>
                    <h4 className="pb-4 mt-4" id="multimedia-video">Diseño Multimedia Adobe</h4>
                    <div className="list-group">
                        <div className="list-group-item">
                            <h6 className="fw-bold">Alto</h6>
                            <p className="mb-0 text-muted">Producción de alto impacto visual con composición de Motion Graphics diseñada a detalle. Incluye una integración avanzada de elementos gráficos, animaciones complejas de capas y postproducción detallada, con locución digital.</p>
                        </div>
                        <div className="list-group-item">
                            <h6 className="fw-bold">Básico</h6>
                            <p className="mb-0 text-muted">Producción basada en material de stock (fotografía o video) con una estructura de slideshow profesional. El diseño gráfico sigue un "look and feel" institucional sobre plantillas sencillas. Incluye transiciones limpias, títulos básicos y locución digital o con música de fondo de librería.</p>
                        </div>
                        <div className="list-group-item">
                            <h6 className="fw-bold">Medio</h6>
                            <p className="mb-0 text-muted">Video con una narrativa visual dinámica que integra elementos animados en pantalla y menús gráficos. La composición incluye gráficos vectoriales, superposición de textos animados y una edición de ritmo moderado con locución digital.</p>
                        </div>
                    </div>
                    <h4 className="pb-4 mt-4">Diseño Multimedia Vyond</h4>
                    <div className="list-group">
                        <div className="list-group-item">
                            <h6 className="fw-bold">Alto</h6>
                            <p className="mb-0 text-muted">Animación de alto impacto con diseño detallado de escenarios, que puede incluir la creación e importación de recursos gráficos externos. La composición visual es compleja, con múltiples acciones simultáneas y una narrativa visual rica. Incluye locución digital.</p>
                        </div>
                        <div className="list-group-item">
                            <h6 className="fw-bold">Básico</h6>
                            <p className="mb-0 text-muted">Animación realizada con escenarios y entornos preestablecidos de la biblioteca de Vyond. Incluye la creación de personajes con rasgos básicos y un dinamismo lineal de acciones y transiciones. Cuenta con locución digital integrada o música de librería estándar.</p>
                        </div>
                        <div className="list-group-item">
                            <h6 className="fw-bold">Medio</h6>
                            <p className="mb-0 text-muted">Producción con un mayor nivel de detalle en la construcción de escenarios y personalización avanzada de personajes (vestimenta y rasgos específicos). El dinamismo de la animación es superior, con movimientos de cámara y acciones de personajes más fluidas. Incluye locución digital sincronizada.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}